module.exports = __webpack_public_path__ + "fonts/nucleo-icons.8224e016.eot";